import { BaseEntity, getCachedStructureEntity } from ".";
import { IGet_markets_region_id_orders_200_ok } from "../service/esiclient";
import { getCachedStationEntity } from "./StationEntityCache";
import moment from "moment";

export class MarketOrderEntity extends BaseEntity {
  private _time: any;
  constructor(id: number, props: any, time: any) {
    super(id, props);
    this._dataTypeName = "Market Order";
    this._time = time;
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    const props: Partial<IGet_markets_region_id_orders_200_ok> = this.props;

    var entity = await super.toJson();

    // Properties
    if (entity.properties) {
      if (props.issued) {
        const issued = moment(props.issued);
        entity.properties["issued"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: issued.unix() / 86400 + 25569,
          numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
        };
      }
      if (this._time !== null) {
        const updated = moment(this._time);
        entity.properties["data_updated"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: updated.unix() / 86400 + 25569,
          numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
        };
      }
      // - Image
      if (entity.properties["type"]) {
        const typeEntity = entity.properties["type"] as Excel.EntityCellValue;
        if (
          typeEntity &&
          typeEntity.properties &&
          Object.prototype.hasOwnProperty.call(typeEntity.properties, "image")
        ) {
          entity.properties["image"] = typeEntity.properties["image"];
        }
      }
      // - Station (Location) or structure
      if (props.location_id) {
        const stationEntity = await getCachedStationEntity(props.location_id);
        if (stationEntity !== null) {
          entity.properties["location"] = await stationEntity.toJson(true);
          delete entity.properties["location_id"];
        } else {
          const structureEntity = await getCachedStructureEntity(props.location_id, 1);
          if (structureEntity !== null) {
            entity.properties["location"] = await structureEntity.toJson(true);
            delete entity.properties["location_id"];
          }
        }
      }
      // - Transaction Type
      const transactionType = props.is_buy_order ? "Buy" : "Sell";
      entity.properties["transaction_type"] = {
        type: Excel.CellValueType.string,
        basicValue: transactionType,
      };
      // - Text and Name
      let typeName = "(unknown)";
      try {
        if (entity.properties && entity.properties["type"]) {
          const type: any = entity.properties["type"];
          typeName = type.properties["name"].basicValue as string;
        }
        // eslint-disable-next-line no-empty
      } catch {}
      const numberOptions = { minimumFractionDigits: 2 };
      const priceVar = props.price?.toLocaleString("en-GB", numberOptions);
      entity.text = `${transactionType} ${props.volume_remain} x ${typeName} @ ${priceVar} ISK`;
      entity.properties["name"] = {
        type: Excel.CellValueType.string,
        basicValue: entity.text,
      };
    }
    if (entity.properties) {
      if (props.type_id) {
        entity.properties["type_id"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: props.type_id,
          numberFormat: "##0",
        };
        delete entity.properties["type"];
      }
    }

    // Layouts
    entity.layouts = {
      card: {
        title: { property: "name" },
      },
    };

    // - Image
    if (
      entity.layouts &&
      entity.layouts.card &&
      entity.properties &&
      Object.prototype.hasOwnProperty.call(entity.properties, "image")
    ) {
      entity.layouts.card.mainImage = { property: "image" };
    }

    return entity;
  }
}
